<template>
  <modal name="login-modal" :adaptive="true" maxWidth="450" maxHeight="550" minHeight="550">
    <div class="modal-content">
      <div class="header">
        <h3>Login</h3>
        <svg
          @click="closeModal()"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.86693 0.296692L7.00013 5.42939L12.1333 0.312246C12.2344 0.20942 12.3557 0.128682 12.4896 0.075138C12.6234 0.0215937 12.767 -0.00359203 12.9111 0.00117351C13.1939 0.0194713 13.4603 0.140054 13.6607 0.340405C13.861 0.540756 13.9816 0.807179 13.9999 1.08993C14.0013 1.22895 13.9745 1.36681 13.921 1.49514C13.8675 1.62347 13.7885 1.73961 13.6888 1.8365L8.54008 7.0003L13.6888 12.1641C13.8911 12.3601 14.003 12.6307 13.9999 12.9107C13.9816 13.1934 13.861 13.4598 13.6607 13.6602C13.4603 13.8605 13.1939 13.9811 12.9111 13.9994C12.767 14.0042 12.6234 13.979 12.4896 13.9255C12.3557 13.8719 12.2344 13.7912 12.1333 13.6884L7.00013 8.57122L1.88249 13.6884C1.78142 13.7912 1.66012 13.8719 1.52624 13.9255C1.39237 13.979 1.24884 14.0042 1.10473 13.9994C0.816683 13.9844 0.544399 13.8633 0.340441 13.6593C0.136483 13.4554 0.0153119 13.1831 0.000318379 12.8951C-0.00108905 12.7561 0.0257604 12.6182 0.0792381 12.4899C0.132716 12.3616 0.211707 12.2454 0.311421 12.1486L5.46017 7.0003L0.295866 1.8365C0.19896 1.7383 0.122843 1.62158 0.0720634 1.49331C0.0212836 1.36503 -0.00311733 1.22784 0.000318379 1.08993C0.018618 0.807179 0.139212 0.540756 0.339583 0.340405C0.539953 0.140054 0.806402 0.0194713 1.08918 0.00117351C1.23216 -0.00561715 1.37502 0.017118 1.50883 0.0679615C1.64264 0.118805 1.76454 0.196667 1.86693 0.296692Z"
            fill="white"
          />
        </svg>
      </div>
      <p class="description">
        Please login to your account in order to share the compare list. Don’t
        have an account yet? <a href="/users/sign_up">Register here</a>
      </p>
      <div class="errors-message" v-if="error_message != ''">Errors: {{error_message}}</div>
      <form @submit="login" class="form-container-contact">
        <label for="email">Email</label>
        <input
          placeholder="abc@example.com"
          type="text"
          autocomplete="off"
          v-model="email"
          id="email"
        />

        <label for="password">Password</label>
        <input
          placeholder="e.g. ABC123#abc"
          type="password"
          autocomplete="off"
          v-model="password"
          id="password"
        />
        <p>
          Forget your password?
          <a class="reset-link" href="/users/password/new">Reset Here</a>
        </p>
        <div class="actions-container">
          <button class="login-button" type="submit">Login</button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: "login-modal",
  data() {
    return {
      email: "",
      password: "",
      error_message: "",
    };
  },
  methods: {
    closeModal() {
      this.$modal.hide("login-modal");
    },
    login(e) {
      e.preventDefault();
      this.error_message = "";
      this.$http
        .post("/api/v1/user/sign_in", {
          user: {
            email: this.email,
            password: this.password,
          },
        })
        .then(() => {
          window.location.reload();
        })
        .catch((e) => {
          this.error_message = e.response?.data?.errors?.join(', ');
        });
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.header svg {
  height: 20px;
  width: 20px;
  cursor: pointer;
}
.modal-content {
  background: #0b0808;
  padding: 24px;
  height: 500px;
  border-radius: 12px;
}
.description {
  padding: 0 20px 24px;
}
.description a,
.reset-link {
  color: #d80000;
}
.vm--modal {
  border-radius: 12px;
}
.form-container-contact {
  background: transparent;
  padding-top: 0;
}
.form-container-contact label {
  color: #fff;
}
.actions-container {
  display: flex;
  justify-content: right;
  margin-top: 24px;
}
.login-button {
  background: #d80000;
  padding: 12px 24px;
  border-radius: 99px;
  color: #fff;
  font-size: 14px;
  margin-left: auto;
}
.errors-message {
  color: red;
  margin: 10px 20px 20px;
  background: #fcb9b9;
  padding: 10px;
  border-radius: 4px;
}
</style>